module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/bone-ab6b88307dadb9956c8a061ded56717f.png";